import script from "./MyBoliaLeftNavigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyBoliaLeftNavigation.vue?vue&type=script&lang=ts&setup=true"

import "./MyBoliaLeftNavigation.vue?vue&type=style&index=0&id=42fb8a60&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42fb8a60"]])

export default __exports__